import { create } from "zustand";
//import { useShallow } from 'zustand/react/shallow'

export const useHplsStore = create((set) => ({
  //HPLS simple variables
  yearNow: new Date().getFullYear(), //initial date values for birthdates
  ageRange: 123, //oldest person ever lived was 122 years and 164 days
  checkButtonClicked: false, //check button clicked
  resetButtonClicked: false, //reset button clicked
  renderToggle: false, //render toggle
  mandatoryFields: [
    "p27__first_name",
    "p27__last_name",
    "p27__date_of_birth",
    "p27__phone1",
    "p27__phone1_description",
    "dc118__Problem1",
    "dc118__InstructionsMatterDescription",
  ],
  AS_FORM_FIELDS: [
    "organization_key",
    "uid",
    "action_id",
    "dc118__WelfareAgencyV2",
    "dc118__HplsClinicApptDateAndTime",
    "dc118__ReferralOrg",
    "p27__first_name",
    "p27__middle_name",
    "p27__last_name",
    "p27__date_of_birth",
    "dc217__Housing",
    "p27__address_line_1",
    "p27__address_line_2",
    "p27__city",
    "p27__post_code",
    "p27__phone1",
    "p27__phone1_description",
    "p27__e_mail",
    "dc118__Problem1[]",
    "dc118__InstructionsMatterDescription",
    "dc118__CriminalMatter",
    "p62__company_flag",
    "p62__company_name",
    "p62__first_name",
    "p62__middle_name",
    "p62__last_name",
    "p62__date_of_birth",
    "dc118__WebformOtherParties",
    "p27__64__CountryOfBirth",
    "p27__gender",
    "p27__class_aboriginal_status",
    "dc217__SafeContact[]",
    "p27__45__Disability1",
    "p27__44__Disability2",
    "p27__46__Disability3",
    "p27__52__Disability4",
    "dc217__IncomeSource",
    "dc217__ReqInterpreter",
    "p27__class_primary_language",
    "dc118__Caseworker",
    "dc118__CaseworkerConsent",
    "dc118__ClientContact",
    "dc118__HplsWebformSubmissionDate",
  ],
  problemsData: [],
  dateInputData: [
    {
      id: "clientDOB",
      day: "Day",
      month: "Month",
      year: "Year",
      dayCount: null,
      is_full_date: false, //valid date?
      dateString: null, //full date string parsed for AS
      text: null,
    },
    {
      id: "otherSideDOB",
      day: "Day",
      month: "Month",
      year: "Year",
      dayCount: null,
      is_full_date: false,
      dateString: null,
      text: null,
    },
    {
      id: "HplsClinicApptDate",
      day: "Day",
      month: "Month",
      year: "Year",
      dayCount: null,
      is_full_date: false,
      dateString: null,
      text: null,
    },
  ],

  //ACTIONS
  updateRenderToggle: (renderToggle) =>
    set(() => ({ renderToggle: renderToggle })),
  updateCheckButtonClicked: (checkButtonClicked) =>
    set(() => ({ checkButtonClicked: checkButtonClicked })),
  setResetButtonClicked: (resetButtonClicked) =>
    set(() => ({ resetButtonClicked: resetButtonClicked })),
  updateDateInputData: (dateInputData) =>
    set(() => ({ dateInputData: dateInputData })),
  updateProblemsData: (problemsData) =>
    set(() => ({ problemsData: problemsData })),
}));
